import { render, staticRenderFns } from "./ActionShareDone.vue?vue&type=template&id=6dd958e6&"
import script from "./ActionShareDone.vue?vue&type=script&lang=js&"
export * from "./ActionShareDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports